import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  height: 42.4px;
  margin: 0;
  padding-left: 10px;
  position: relative;
  max-width: calc(100% - 55px);

  .election-hub__search-filter-label {
     align-items: center;
     background-color: #eaeaea;
     border-radius: 20px;
     display: flex;
     justify-content: space-between;
     margin-top: 5px;
     padding: 0px 10px 0px 15px;
     user-select: none;
     
     .election-hub__search-filter-label--text {
        color: #000000;
        cursor: default;
        display: inline-block;
        font-size: 1rem;
        line-height: 2;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        vertical-align: middle;
        white-space: nowrap;
     }

     .election-hub__search-filter-label--remove-button {
          display: inline-block;
          font-size: 1.2rem;
          margin: 0px 5px 0px 5px;

          &:hover {
            color: #5d5d5d;
            cursor: pointer;
          }    

          &:focus {
            outline: none;
          }  
      }  
    }
    
`;

export default {
  Wrapper,
};
